import BaseApiAction from '@Actions/base-api-action';

export default class DeleteInvite extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-deleteInvite',
      payload: {
        invite_id: this._payload.invite_id,
      },
      disableLoaders: true
    });
  }
}
